var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#ADB1C9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3ZM12 19.2C8.02355 19.2 4.8 15.9764 4.8 12C4.8 8.02355 8.02355 4.8 12 4.8C15.9764 4.8 19.2 8.02355 19.2 12C19.2 15.9764 15.9764 19.2 12 19.2ZM14.7898 12.5669L12.9 11.4776V7.50239C12.9 7.00533 12.4971 6.60239 12 6.60239C11.5029 6.60239 11.1 7.00533 11.1 7.50239V12.1137C11.1055 12.1756 11.1208 12.2363 11.1453 12.2934C11.164 12.3467 11.1882 12.3978 11.2177 12.446C11.2423 12.4971 11.2724 12.5454 11.3075 12.5899L11.4514 12.7068L11.5309 12.7863L13.8724 14.1307C14.1521 14.2915 14.4964 14.2908 14.7756 14.1289C15.0547 13.967 15.2262 13.6684 15.2256 13.3458C15.2249 13.0231 15.0521 12.7253 14.7724 12.5645L14.7898 12.5669Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.be3e7b69.svg";
export { ForwardRef as ReactComponent };